import { FunctionComponent, useEffect, useState } from 'react';

// Components
import Anchor from '.';

interface ShareProps {
    href?: string;
    className?: string;
}

const Share: FunctionComponent<ShareProps> = (props) => {
    const [href, setHref] = useState<string>(props.href);

    useEffect(() => {
        if (!props.href) {
            setHref(window.location.href);
        }
    }, []);

    return (
        <Anchor target={'_blank'} rel="noreferrer" className={props.className} href={`https://www.facebook.com/sharer/sharer.php?u=${href}`}>
            {props.children}
        </Anchor>
    );
};

Share.defaultProps = {};

export default Share;
